import { INPUT_MSG } from "@/consts/message";
import { useNavigate } from "react-router-dom";
import * as ViewModel from "@/core/presenter/viewModel";

interface IProps {
    isPinCheckFailed: boolean;
}

const PinGuideTextArea = ({ isPinCheckFailed }: IProps) => {
    const navigate = useNavigate();

    const onClickResetPin = () => {
        navigate('/setting', {
            state: {
                viewType: ViewModel.SettingViewType.PIN_SETTING
            }
        });
    };

    return (
        <>
            <p className="pin-recovery text-sm font-semibold center">{isPinCheckFailed ? INPUT_MSG.PIN_CHECK_FAILED : ''}</p>
            <span
                className="pin-recovery underline text-sm font-semibold center"
                onClick={onClickResetPin}
                style={{ cursor: 'pointer' }}
            >
                PIN 비밀번호 재설정
            </span>
        </>
    )
}

export default PinGuideTextArea;